export type MoveDirection = -1 | 1;

export function removeItem(items: { id: string }[], id: string): number {
  const index = items.findIndex((item) => item.id === id);
  if (index < 0) throw new Error(`Missing item: ${id}`);
  items.splice(index, 1);
  return index;
}

export function moveItemBy(
  items: { id: string }[],
  id: string,
  direction: MoveDirection,
): number | null {
  const index = items.findIndex((item) => item.id === id);
  if (index < 0) throw new Error(`Missing item: ${id}`);

  const targetIndex = index + direction;
  if (targetIndex < 0 || targetIndex >= items.length) {
    return null;
  }

  const item = items[index];
  const target = items[targetIndex];
  items[index] = target;
  items[targetIndex] = item;
  return targetIndex;
}

export function moveItemTo(
  items: { id: string }[],
  id: string,
  targetId: string,
  side: "before" | "after",
): number | null {
  const fromIndex = requireItemIndex(items, id, "item");
  if (id === targetId) {
    return null;
  }

  const toIndex = requireItemIndex(items, targetId, "target item");
  const destination = side === "before" ? toIndex : toIndex + 1;
  if (destination === fromIndex || destination === fromIndex + 1) return null;

  const item = items.splice(fromIndex, 1)[0];
  const adjustedTargetIndex = items.findIndex(
    (candidate) => candidate.id === targetId,
  );
  const index =
    side === "before" ? adjustedTargetIndex : adjustedTargetIndex + 1;
  items.splice(index, 0, item);
  return index;
}

function requireItemIndex(
  items: readonly { id: string }[],
  id: string,
  description: "item" | "target item",
): number {
  const index = items.findIndex((item) => item.id === id);
  if (index < 0) throw new Error(`Missing ${description}: ${id}`);
  return index;
}
